import type { ReactNode } from 'react';

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';

type PhotoPreviewDialogProps = {
  src: string;
  title: string;
  /** The thumbnail / button that opens the preview. Leave out to control it with `isOpen`. */
  children?: ReactNode;
  isOpen?: boolean;
  onClose?: () => void;
};

export const PhotoPreviewDialog = (props: PhotoPreviewDialogProps) => {
  const { src, title, children, isOpen, onClose } = props;

  const onOpenChange = (isDialogOpen: boolean) => {
    if (!isDialogOpen) {
      onClose?.();
    }
  };

  return (
    <Dialog
      open={isOpen}
      onOpenChange={onOpenChange}
    >
      {children && <DialogTrigger asChild>{children}</DialogTrigger>}
      <DialogContent className="sm:max-w-2xl">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription className="sr-only">{title}</DialogDescription>
        </DialogHeader>
        <img
          src={src}
          alt={title}
          className="max-h-[75vh] w-full rounded-lg object-contain"
        />
      </DialogContent>
    </Dialog>
  );
};
